import { ITranslationEntry } from '../lang';

export const SQ: ITranslationEntry = {
  translations: {
    notifications: 'Njoftimet',
    markAllAsRead: 'Shënoni të gjitha si të lexuara',
    poweredBy: 'Mundësuar nga',
    settings: 'Cilësimet',
  },
  lang: 'sq',
};
